import React from 'react';
import PrepSharpMov from 'assets/mp4/prepsharp.mp4';

import './index.css';

function Loader() {
    return (
      <div className='loader'>
        <video
          className='loader__video'
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={PrepSharpMov} type='video/mp4'></source>
        </video>
      </div>
    );
}

export default Loader;